<template>
  <div>
    <div class="card mb-2">
      <div class="card-header px-2 py-2 d-flex justify-content-between align-items-center">
        <h5 class="d-flex justify-content-between align-items-center font-weight-bold text-muted m-0">
          <button
            class="btn btn-link text-muted font-weight-bold p-0 header-btn"
            @click="ui.show = !ui.show"
          >
            Tags/Features
          </button>
          <button
            type="button"
            class="btn btn-link btn-sm"
            @click="removeAllRules"
            :disabled="$props.disabled || $props.value.length === 0"
          >
            Delete Rules
          </button>
        </h5>
      </div>
      <div
        v-show="ui.show"
        class="card-body px-2 py-2"
      >
        <tag-pills
          :tags="$props.property.Tags || []"
          v-model="rules"
          :disabled="$props.disabled"
        />
      </div>
    </div>
  </div>
</template>
<script>
import TagPills from '../TagPills.vue';

export default {
    data: () => ( {
        ui: {
            show: true
        },
        rules: []
    } ),
    methods: {
        reset() {
            this.ui = this.initialState;
            this.rules = [];
        },
        removeAllRules() {
            this.rules = [];
        },
        validate() {
            let state = {
                valid: true,
                msg: ''
            };

            return state;
        }
    },
    watch: {
        rules: {
            immediate: true,
            handler: function() {
                this.$emit( 'input', this.rules );
            }
        }
    },
    created() {
        this.initialState = this.ui;
        this.rules = this.$props.value;
    },
    props: {
        property: {
            required: false,
            type: Object,
            default: () => ( {
                Tags: []
            } )
        },
        value: {
            required: false,
            type: Array,
            default: () => []
        },
        disabled: {
            required: true,
            type: Boolean,
            default: () => false
        }
    },
    components: {
        TagPills
    }
};
</script>



// WEBPACK FOOTER //
// src/components/property-qc/handlers/FeatureRuleHandler.vue